import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import TopNav from '../../components/TopNav'
import LoadError from '../../components/LoadError'
import { loadList } from '../../utils/loadState'
import { getConnectorVendors } from '../../api'
import './VendorLibrary.css'

export default function VendorLibrary() {
  const [vendors, setVendors] = useState([])
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(true)
  // A failed load is an error with a Retry, never "0 vendors" (item 201).
  const [loadError, setLoadError] = useState(null)

  async function load() {
    setLoading(true)
    const { items, error } = await loadList(getConnectorVendors, 'vendors')
    setVendors(items || [])
    setLoadError(error)
    setLoading(false)
  }

  useEffect(() => { load() }, [])

  const filtered = vendors.filter(v =>
    v.vendor_id?.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <>
      <TopNav breadcrumbs={[{ label: 'Admin', href: '/admin' }, { label: 'Vendor Library' }]}
        actions={<><Link to="/admin" className="nav-btn">Dashboard</Link></>} />
      <div className="vl-page">
        <div className="vl-header">
          <div><h1 className="vl-title">Vendor Library</h1><p className="vl-subtitle">{loadError ? 'Vendors could not be loaded' : `${vendors.length} vendors with schema definitions`}</p></div>
          <input className="vl-search" placeholder="Search vendors…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>

        {loading ? (
          <div className="vl-loading"><div className="vl-spinner" /><p>Loading…</p></div>
        ) : loadError ? (
          <LoadError what="vendors" error={loadError} onRetry={load} />
        ) : (
          <div className="vl-grid">
            {filtered.map(v => (
              <div key={v.vendor_id} className="vl-card">
                <div className="vl-card-badge">{v.vendor_id?.slice(0, 3).toUpperCase()}</div>
                <div className="vl-card-name">{v.vendor_id}</div>
                <div className="vl-card-products">
                  {v.products?.map(p => <span key={p} className="vl-product-chip">{p}</span>)}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  )
}
